/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Data_LoadingInputs */

const vi_station_data_loading = /** @type {(inputs: Station_Data_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang cập nhật danh sách đơn…`)
};

/**

* @param {Station_Data_LoadingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_data_loading = /** @type {((inputs?: Station_Data_LoadingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Data_LoadingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_data_loading(inputs)
});